export type NotificationChannel = "push" | "telegram" | "panel";

/** `GET /notifications` javobidagi bitta qator. */
export interface NotificationItem {
	id: string;
	type: string;
	/** Server shablondan chiqargan o'zbekcha matn (`renderNotification`). */
	title: string;
	body: string;
	triggerRef: string;
	payload: unknown;
	readAt: string | null;
	createdAt: string;
}

/** `{ "<xabar turi>": ["push", "telegram"] }` — `notification_channels`. */
export type NotificationChannelsMap = Record<string, NotificationChannel[]>;

/**
 * `GET/PUT /settings/telegram-bot-token` javobi — XOM token HECH QACHON
 * kelmaydi (backend `settings.repository.ts`ning `telegramBotTokenStatus()`
 * iga qarang). `source: "env"` — DB'da qator yo'q, lekin server `.env`ida
 * token bor (worker shu bilan ishlaydi, panel orqali tahrirlanmaydi).
 */
export interface TelegramBotTokenStatus {
	configured: boolean;
	last4: string | null;
	updatedAt: string | null;
	source: "db" | "env" | "none";
	/**
	 * Botning `@username`i — endi TOKENDAN Telegram'ning `getMe` metodi
	 * orqali avtomatik aniqlanadi, qo'lda kiritilmaydi.
	 * `source: "db"` bo'lsa doim to'ldirilgan; `"env"` bo'lsa `null`
	 * bo'lishi mumkin (o'sha token hali panel orqali aylanmagan).
	 */
	username: string | null;
}

/**
 * Turlarning o'zbekcha nomlari.
 *
 * ⚠️ `packages/core` dagi `NOTIFICATION_TYPES` bu yerga IMPORT QILINMAYDI —
 * u backend/worker paketi, frontend uning bog'liqligi emas
 * (`settings/types/index.ts` dagi bir xil qaror). Noma'lum tur uchun
 * kalitning o'zi ko'rsatiladi, ya'ni yangi tur qo'shilsa ekran buzilmaydi.
 */
export const NOTIFICATION_TYPE_LABELS: Record<string, string> = {
	// biome-ignore lint/style/useNamingConvention: xabar turi kaliti backend bilan bir xil
	davomat_qabul: "Davomat qabul qilindi",
	// biome-ignore lint/style/useNamingConvention: xabar turi kaliti backend bilan bir xil
	davomat_rad: "Davomat rad etildi",
	// biome-ignore lint/style/useNamingConvention: xabar turi kaliti backend bilan bir xil
	ruxsatsiz_chiqish: "Ruxsatsiz chiqish",
	// biome-ignore lint/style/useNamingConvention: xabar turi kaliti backend bilan bir xil
	fake_location: "Soxta joylashuv",
	// biome-ignore lint/style/useNamingConvention: xabar turi kaliti backend bilan bir xil
	uzoq_oflayn: "Uzoq vaqt oflayn",
	// biome-ignore lint/style/useNamingConvention: xabar turi kaliti backend bilan bir xil
	smena_boshlanishi: "Smena boshlanishi",
	// biome-ignore lint/style/useNamingConvention: xabar turi kaliti backend bilan bir xil
	yangi_qurilma: "Yangi qurilmadan kirish",
};

export function notificationTypeLabel(type: string): string {
	return NOTIFICATION_TYPE_LABELS[type] ?? type;
}

/** ⚠️ SMS va elektron pochta YO'Q — TT §316 qat'iy (spec §7.2). */
export const CHANNEL_LABELS: Record<NotificationChannel, string> = {
	push: "Push",
	telegram: "Telegram",
	panel: "Panel",
};
